var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZunuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.289062 9.31371C0.289062 7.79534 1.51995 6.56445 3.03832 6.56445C4.55669 6.56445 5.78758 7.79534 5.78758 9.31371V11.5783C5.78758 11.8552 5.5631 12.0797 5.28619 12.0797H0.790444C0.513538 12.0797 0.289062 11.8552 0.289062 11.5783V9.31371Z",
    fill: "#7AA2F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4922 9.63244C12.4922 11.1158 11.2897 12.3184 9.80626 12.3184C8.32287 12.3184 7.12034 11.1158 7.12034 9.63244L7.12034 7.42018C7.12034 7.14966 7.33964 6.93036 7.61016 6.93036L12.0024 6.93036C12.2729 6.93036 12.4922 7.14966 12.4922 7.42018L12.4922 9.63244Z",
    fill: "#497FEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.289063 0.294458C0.289063 0.176059 0.385044 0.0800781 0.503442 0.0800781H4.6043C4.79513 0.0800781 4.89085 0.310675 4.75611 0.44582L0.655259 4.55901C0.520301 4.69437 0.289063 4.59879 0.289063 4.40764L0.289063 0.294458Z",
    fill: "#405FEC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.78906 5.38132C5.78906 5.49972 5.69308 5.5957 5.57468 5.5957L1.47383 5.5957C1.28299 5.5957 1.18727 5.36511 1.32201 5.22996L5.42287 1.11678C5.55782 0.981411 5.78906 1.07699 5.78906 1.26814L5.78906 5.38132Z",
    fill: "#405FEC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4922 2.84449C12.4922 4.36287 11.2613 5.59375 9.74293 5.59375C8.22456 5.59375 6.99367 4.36287 6.99367 2.84449L6.99367 0.580072C6.99367 0.303174 7.21814 0.0787039 7.49504 0.0787039L11.9908 0.0787043C12.2677 0.0787043 12.4922 0.303174 12.4922 0.580072L12.4922 2.84449Z",
    fill: "#497FEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZunuIcon);
export default __webpack_public_path__ + "static/media/zunu_icon.e8d8339fca14f53ea464db2a79b05356.svg";
export { ForwardRef as ReactComponent };